"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var material_1 = require("@mui/material");
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_toastify_1 = require("react-toastify");
var trans_1 = __importDefault(require("@/plugins/trans"));
var VacancyAlertFrequency = function () {
    var _a = (0, react_1.useState)('DAILY'), frequency = _a[0], setFrequency = _a[1];
    var _b = (0, react_1.useState)(true), hide = _b[0], setHide = _b[1];
    (0, react_1.useEffect)(function () {
        axios_1.default.post('/vacancy-alerts/getFrequency').then(function (_a) {
            var data = _a.data;
            setFrequency((data === null || data === void 0 ? void 0 : data.frequency) || 'DAILY');
            setHide(!(data === null || data === void 0 ? void 0 : data.frequency));
        });
    }, []);
    var handleChange = function (event) {
        var chosenFrequency = event.target.value;
        setFrequency(chosenFrequency);
        axios_1.default
            .post('/vacancy-alerts/changeFrequency', { frequency: chosenFrequency })
            .then(function (_a) {
            var data = _a.data;
            react_toastify_1.toast.success(data.message, {
                position: 'bottom-right',
                autoClose: 5000,
                hideProgressBar: true,
                pauseOnHover: false,
            });
        })
            .catch(function (_a) {
            var data = _a.data;
            react_toastify_1.toast.error(data.message, {
                position: 'bottom-right',
                autoClose: 5000,
                hideProgressBar: true,
                pauseOnHover: false,
            });
        });
    };
    if (hide) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ id: "alertFrequencyLabel" }, { children: trans_1.default.get('labels.general.alert_frequency') })), (0, jsx_runtime_1.jsxs)(material_1.Select, __assign({ labelId: "alertFrequencyLabel", value: frequency, label: trans_1.default.get('labels.general.alert_frequency'), onChange: handleChange }, { children: [(0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: "DIRECT" }, { children: trans_1.default.get('labels.general.frequency.direct') })), (0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: "DAILY" }, { children: trans_1.default.get('labels.general.frequency.daily') })), (0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: "WEEKLY" }, { children: trans_1.default.get('labels.general.frequency.weekly') }))] }))] }));
};
exports.default = VacancyAlertFrequency;
